// extracted by mini-css-extract-plugin
export default {"homeContainer":"homeContainer--3hpiA","topFold":"topFold--cyisT"};